import styled from 'styled-components';
import Input from '../../atoms/Input';

export const StyledInput = styled(Input)`
	margin: 25px 0;
`;
